import { render, staticRenderFns } from "./SkillTable.vue?vue&type=template&id=4793ab64&scoped=true"
import script from "./SkillTable.vue?vue&type=script&lang=js"
export * from "./SkillTable.vue?vue&type=script&lang=js"
import style0 from "./SkillTable.vue?vue&type=style&index=0&id=4793ab64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4793ab64",
  null
  
)

export default component.exports